export const tags = (t) => [
    {
        id: 'brand_to_entities_to_prompts',
        label: t('ai_tracking.prompt_generator.tags.brand_to_entities_to_prompts'),
    },
    { id: 'entities', label: t('ai_tracking.prompt_generator.tags.entities') },
];
